import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { Guid } from './entities';

@Injectable({ providedIn: 'root' })
export class PortalService {
    static serviceName: string;
    constructor(private http: HttpClient) {
        PortalService.serviceName = `${environment.apiUrl}/portal`;
    }

    async getStripePublicKey() {
        const result = await this.http.post(`${PortalService.serviceName}/getStripePublicKey`, {}).toPromise();
        return result;
    }

    async getInvoice(code: string) {
        const result = await this.http.get(`${PortalService.serviceName}/getInvoice/${code}`, {}).toPromise();
        return result;
    }

    async submitPayment(nameOnCard: string, cardNumber: number, securityCode: number, expirationMonth: number, expirationYear: number, code: Guid) {
        const result = await this.http
            .post(`${PortalService.serviceName}/submitPayment`, {
                nameOnCard,
                cardNumber,
                securityCode,
                expirationMonth,
                expirationYear,
                code
            })
            .toPromise();
        return result;
    }

    async createPaymentIntent(code: Guid) {
        const result = await this.http
            .post(`${PortalService.serviceName}/createPaymentIntent`, {
                invoiceCode: code
            })
            .toPromise();
        return result;
    }

    async markedAsPaid(code: Guid, results: string) {
        const result = await this.http
            .post(`${PortalService.serviceName}/markedAsPaid`, {
                invoiceCode: code,
                paymentIntentResult: results
            })
            .toPromise();
        return result;
    }
}
